import { render } from "./selection-tab.vue?vue&type=template&id=4453568c"
import script from "./selection-tab.vue?vue&type=script&lang=js"
export * from "./selection-tab.vue?vue&type=script&lang=js"

import "./selection-tab.vue?vue&type=style&index=0&id=4453568c&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__